<app-agent-breadcrumb></app-agent-breadcrumb>

<div class="page-header home no-margin-left">
  <h1 class="page-title">Corporate Income Tax Review Agent</h1>
  <p class="page-text">
    The Corporate Income Tax Review enhances the review process by identifying
    discrepancies and anomalies within financial statements and CIT
    computations.
  </p>
</div>
<!--  -->
@if(currentTab.tabNumberOrder !== 1){
<app-tab-list
  [tabs]="tabs"
  [currentTab]="currentTab"
  [size]="'full'"
  (currentTabEmitter)="toggleTabOnNumber($event)"
></app-tab-list>
}
<!--  -->
@if(feedbackSurveyKey){
<app-feedback [surveyKey]="feedbackSurveyKey"></app-feedback>
}

<div class="tab-content">
  @if(currentTab.tabNumberOrder === 1){
  <app-agent-five-home
    (tabNumberEmitter)="toggleTabOnNumber($event)"
  ></app-agent-five-home>
  } @if(currentTab.tabNumberOrder !== 1){
  <app-agent-five-tab
    [tabNumber]="currentTab.tabNumberOrder"
    (tabNumberEmitter)="toggleTabOnNumber($event)"
    (emittedReportId)="assignProjectIdToFeedback($event)"
  ></app-agent-five-tab>
  }
</div>

<app-disclaimer></app-disclaimer>
